import { OrderClassEnum } from '@modules/orders-module/enums/order-class.enum'

export const OrderClasses: OrderClassEnum[] = [OrderClassEnum.BRACKET, OrderClassEnum.OCO, OrderClassEnum.OTO]
